// extracted by mini-css-extract-plugin
export default {"ending":"ending__4EQTA","img":"img__MK+GP","content":"content__L7G8g"};